import gql from "graphql-tag";
import { platform } from "~/platform/socket";
import type { Document } from "../types";

export const getDocument: (id: string) => Promise<{
	document: Document;
	documentKeywords: string[][];
}> = (id: string) => {
	return platform.query(
		gql`
		query FetchDocument ($id: ID!) {
			documentKeywords
			document(id: $id) {
				shortName
				latestBuild(channel: PUBLIC) {
					buildNumber
					articles {
						id
						content
						title
						tocTitle
						tocSubtitle
						breadcrumb
						isSubHeading
						isProtected
						isHeading
						indentLevel
						headingColor
						isViewable
					}
					assets(scope: WEB) {
						fileName
						storageUrl
					}
					moreinfo {
						id
						title
						content
					}
				}
			}
		}
	`,
		{
			id: id,
		},
	);
};
